<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
	{{TR "Rechte übertragen"}} - {{name}}
	</h4>
</div>
<div class="modal-body">
	{{#if errors.error}}
	<div class="alert alert-danger">
		{{TR errors.error}} {{#if errors.sysErr}}({{ERROR_TR errors.sysErr}}){{/if}}
	</div>
	{{/if}}
	<div class="row">
		<div class="col-md-12">
			<div class="alert alert-warning">
				<strong>{{TR 'Achtung'}}</strong> {{TR 'Sie übertragen alle Ihre Rechte und Freigaben an einen anderen Nutzer. Sobald dieser dem Transfer zustimmt, können Sie die existierenden Freigaben nicht mehr verwalten.'}}<br><br>{{TR 'Sie behalten Ihre Rechte auf diesem Gerät.'}}
			</div>
			<div class="form-group">
				<label for="email-input" class="control-label">{{TR 'Neuer Verwalter'}}</label>
				<input type="email" class="form-control {{#if errors.email}}parsley-error{{/if}}" id="email-input" placeholder="{{TR 'E-Mail Adresse'}}" name="email" value="{{formData.email}}">
				{{#if errors.email}}
				<ul class="parsley-errors-list filled" id="email-error">
					<li class="parsley-required">{{TR "E-Mail ist"}} {{TR errors.email}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{TR "Übertragen"}}</button>
</div>
